/**
 * Rótulos e datas do caso no portal (E148 — GUS-109): o que a peça é, de que documento é o laudo
 * e as datas no fuso de quem opera.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { TipoDaPeca } from '@/lib/exame_eletronico_protocolo';

const tc = ptBR.casoDoPortal;
const tiposDaPeca = ptBR.exameEletronico.tabelaDePecas.tipoDaPeca;

/** Data civil (`AAAA-MM-DD`) ou instante, como dia/mês/ano. */
export function formatarData(iso: string): string {
  const soData = !iso.includes('T');
  const d = new Date(soData ? `${iso}T00:00:00Z` : iso);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: soData ? 'UTC' : 'America/Sao_Paulo',
  }).format(d);
}

/** Instante como dia/mês/ano e hora, no fuso de quem opera. */
export function formatarDataHora(iso: string): string {
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Sao_Paulo',
  }).format(new Date(iso));
}

/** O que a peça é (GUS-139): o tipo lido; sem tipo, o número da CCB; sem nenhum, "Documento". */
export function rotuloDaPeca(peca: {
  tipo_da_peca?: TipoDaPeca | null;
  ccb_number: string | null;
}): string {
  const tipo = peca.tipo_da_peca ?? null;
  if (tipo !== null && tipo !== 'outro') {
    const rotulo = tiposDaPeca[tipo];
    return tipo === 'ccb' && peca.ccb_number ? `${rotulo} ${peca.ccb_number}` : rotulo;
  }
  return peca.ccb_number ?? tc.pecas.semTipo;
}

/** De que documento é o laudo: "da CCB 4103" ou, sem número, "do contrato". */
export function documentoDoLaudo(versao: { ccb_number: string | null }): string {
  return versao.ccb_number
    ? tc.documentoDoLaudo.ccb.replace('{{numero}}', versao.ccb_number)
    : tc.documentoDoLaudo.contrato;
}
